module.exports = __webpack_public_path__ + "images/smile-licky.png";